<template>
  <div class="registration-form">
    <h2>Register</h2>
    <form @submit.prevent="handleRegister">
      <div class="input-group">
        <label for="email">Email:</label>
        <input type="email" id="email" v-model="registrationData.email" required />
      </div>
      <div class="input-group">
        <label for="firstName">First Name:</label>
        <input type="text" id="firstName" v-model="registrationData.firstName" required />
      </div>
      <div class="input-group">
        <label for="lastName">Last Name:</label>
        <input type="text" id="lastName" v-model="registrationData.lastName" required />
      </div>
      <div class="input-group">
        <label for="password">Password:</label>
        <input type="password" id="password" v-model="registrationData.password" required />
      </div>
      <div class="input-group">
        <label for="passwordConfirm">Confirm Password:</label>
        <input type="password" id="passwordConfirm" v-model="registrationData.passwordConfirm" required />
      </div>
      <div class="input-group">
        <label for="username">Username (optional):</label>
        <input type="text" id="username" v-model="registrationData.username" />
      </div>
      <button type="submit">Register</button>
    </form>
    <p v-if="errorMessage" class="error-message">{{ errorMessage }}</p>
  </div>
</template>

<script>
import registrationService from '@/services/registrationService';

export default {
  name: "RegistrationForm",
  data() {
    return {
      registrationData: {
        email: "",
        firstName: "",
        lastName: "",
        password: "",
        passwordConfirm: "",
        username: "",
      },
      errorMessage: "",
    };
  },
  methods: {
    async handleRegister() {
      try {
        await registrationService.registerUser(this.registrationData);
        this.$router.push("/login"); // Redirect to login after successful registration
      } catch (error) {
        this.errorMessage = "Registration failed. Please try again.";
      }
    },
  },
};
</script>

<style scoped>
.registration-form {
  width: 300px;
  margin: 50px auto;
  padding: 20px;
  border: 1px solid #ccc;
  border-radius: 5px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
}
.input-group {
  margin-bottom: 15px;
}
label {
  display: block;
  margin-bottom: 5px;
}
input {
  width: 100%;
  padding: 8px;
  box-sizing: border-box;
}
button {
  width: 100%;
  padding: 10px;
  background-color: #007bff;
  color: #fff;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}
.error-message {
  color: red;
  margin-top: 10px;
}
</style>